import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import deepMerge from 'deepmerge';
import { colorAttributesList, displayAttributesList, marginAttributesList, paddingAttributesList, sizeAttributesList, styleAttributesList, textAlignmentAttributesList } from '../system/attributes';
export { default as generateId } from './generateId';
export { default as getElementName } from './getElementName';
export { default as useDetectClickOutsideComponent } from './useDetectClickOutsideComponent';
export * from './useDetectEscapeKeyPressed';
export * from './useInternalRef';
export * from './dropdown';
export * from './noop';
export * from './stringEllipsisAtMaxCharacters';
export var makeBEM = function makeBEM(block, element, modifier) {
  return "".concat(block, "-").concat(element).concat(modifier ? "--".concat(modifier) : '');
};
export var appendBEMModifier = function appendBEMModifier(blockElement, modifier) {
  return "".concat(blockElement, "--").concat(modifier);
};
export var appendBEMModifierOnCondition = function appendBEMModifierOnCondition(blockElement, modifier, condition) {
  return condition ? "".concat(blockElement, "--").concat(modifier) : '';
};
export var appendClassName = function appendClassName(classNames, className) {
  return "".concat(classNames, " ").concat(className || '').trim();
};
export var makeRootClassName = function makeRootClassName(classPrefix, className) {
  return appendClassName(makeBEM(classPrefix, 'Root'), className);
};
export var merge = function merge(dst, src) {
  return deepMerge(dst, src || {}, {
    arrayMerge: function arrayMerge(destinationArray, sourceArray) {
      return sourceArray;
    }
  });
};

var atomicPropsList = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, marginAttributesList), paddingAttributesList), styleAttributesList), sizeAttributesList), textAlignmentAttributesList), displayAttributesList), colorAttributesList);

var _shouldForwardProp = function shouldForwardProp(property) {
  var componentPropertyList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var blockAtomicProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return !(property in componentPropertyList) && !(blockAtomicProps && property in atomicPropsList);
};

export { _shouldForwardProp as shouldForwardProp };
export var getPropsBlocker = function getPropsBlocker(propertyList) {
  var blockAtomicProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return {
    shouldForwardProp: function shouldForwardProp(propertyName) {
      return _shouldForwardProp(propertyName, propertyList, blockAtomicProps);
    }
  };
};
export * from './makePropList';